<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div
      class="users-list min-height-100"
      v-loading="loading">
      <el-button
        v-if="role.name==='zeus'"
        @click="addUserDialogVisible = true"
        type="success"
        icon="el-icon-plus"
        size="small">
        {{ $t('add_user') }}
      </el-button>
      <div
        v-if="users !== null"
        class="mt-15">
        <search
          :options="['name', 'email', 'mobile']"
          :name="`${domainsPath}/users`"
          @list-updated="query = $event" />
        <el-table
          :data="users.list"
          border
          style="width: 100%"
          class="mb-15 mt-15">
          <el-table-column
            prop="name"
            :label="$t('name')"
            width="180">
          </el-table-column>
          <el-table-column
            :label="$t('email')"
            width="280">
            <template slot-scope="scope">
              <div class="ltr tahoma">
                {{ scope.row.email }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('mobile')">
            <template slot-scope="scope">
              <div class="ltr tahoma">
                {{ scope.row.mobile }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('confirmation_status')">
            <template slot-scope="scope">
              <el-tag
              :type="scope.row.confirmation_status === 'confirmed' ?
                'success' : 'danger'"
              class="no-margin">
                {{ $t(scope.row.confirmation_status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            align="right" width="280">
            <template slot="header">
              {{ $t('tools') }}
            </template>
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('customers')"
                placement="top-start">
                <router-link
                  :to="{ name: 'customer-teams', params: {id: scope.row.id.numberStr}, query:{name: scope.row.name} }"
                  class="el-button el-button--info el-button--mini is-plain">
                  <i class="fas fa-user-tag"></i>
                </router-link>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('edit')"
                placement="top-start">
                <el-button
                  size="mini"
                  type="warning"
                  plain
                  @click="handleEditUserClick(scope.row, scope.$index)">
                  <i class="fas fa-pen"></i>
                </el-button>
              </el-tooltip>
              <el-tooltip
                v-if="role.name==='zeus' || role.name==='account_manager'"
                class="item"
                effect="dark"
                :content="$t('teams')"
                placement="top-start">
                  <router-link
                  :to="{ name: 'user', params: {id: scope.row.id.numberStr} }"
                  class="el-button el-button--info el-button--mini is-plain">
                  <i class="fas fa-users"></i>
                </router-link>
              </el-tooltip>
              <el-tooltip
              class="item"
              effect="dark"
              :content="$t('sign_in_to_user_panel')"
              placement="top-start">
                <el-button
                  size="mini"
                  type="info"
                  style="background-color: #7047EB; border-color: #7047EB; color: #fff;"
                  plain
                  @click="autoLoginToClientPanel(scope.row)">
                  <i class="fas fa-sign-in-alt"></i>
                </el-button>
              </el-tooltip>
              <el-tooltip
              class="item"
              effect="dark"
              content="ورود به پنل قدیم"
              placement="top-start">
                <el-button
                  size="mini"
                  type="info"
                  plain
                  @click="autoLoginToOldClientPanel(scope.row)">
                  <i class="fas fa-sign-in-alt"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="users.total"
          :page-size="limit"
          :current-page.sync="currentPage">
        </el-pagination>
      </div>
      <el-dialog
        :title="$t('edit_user')"
        :visible.sync="dialogVisible"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <edit
        :user="userForm"
        @close-clicked="dialogVisible = false"
        @user-updated="updateUserRow($event)"/>
      </el-dialog>
      <el-dialog
        :title="$t('add_user')"
        :visible.sync="addUserDialogVisible"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @closed="$refs.addUser.$refs.addUserForm.resetFields()">
        <add
        :user="userForm"
        @close-clicked="addUserDialogVisible = false"
        @user-added="addUserRow($event)"
        ref="addUser"/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Edit from '@/components/users/Edit'
import Add from '@/components/users/Add'
import Search from '@/components/global/Search'

export default {
  data () {
    return {
      addUserDialogVisible: false,
      dialogVisible: false,
      currentPage: 1,
      loading: false,
      currentRow: 0,
      user: null,
      limit: 10,
      total: 0,
      query: {}
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath',
      'users',
      'self',
      'role'
    ]),
    offset () {
      return (this.currentPage - 1) * this.limit
    },
    userForm () {
      const { user } = this
      if (user !== null) {
        const { name, email, mobile, id } = user
        return {
          name,
          email,
          mobile,
          id: id.numberStr
        }
      }
      return {}
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    updateUserRow (user) {
      const { currentRow } = this
      this.users.list[currentRow] = user
      this.getData()
    },
    addUserRow (user) {
      this.users.list.push(user)
    },
    toggleLoading () {
      this.loading = !this.loading
    },
    redirectUserToClientPanel (res) {
      const { link } = res
      const url = `https://${process.env.VUE_APP_SERVER_URL}/autologin?link=${link}?operator_id=${this.self.id.numberStr}`
      window.open(url, '_blank')
    },
    redirectUserToOldClientPanel (res) {
      const { link } = res
      const url = `https://newpanel.newsbx.com/#/autologin?link=${link}?operator_id=${this.self.id.numberStr}`
      window.open(url, '_blank')
    },
    handleEditUserClick (user, index) {
      this.dialogVisible = true
      this.currentRow = index
      this.password = ''
      this.user = user
    },
    handleAuthSuccess (res, user) {
      localStorage.setItem('server_access_token', res.access_token)
      const { domainsPath } = this
      const clientID = process.env.VUE_APP_CLIENT_ID
      const name = `${domainsPath}/clients/${clientID}/users/${user.id.numberStr}/links/oauth`
      this.handleRequest({
        name,
        action: 'getAll',
        tokenScope: 'server'
      }).then(this.redirectUserToClientPanel)
        .finally(this.toggleLoading)
    },
    handleOldClientAuthSuccess (res, user) {
      localStorage.setItem('server_access_token', res.access_token)
      const { domainsPath } = this
      const clientID = process.env.VUE_APP_CLIENT_ID
      const name = `${domainsPath}/clients/${clientID}/users/${user.id.numberStr}/links/oauth`
      this.handleRequest({
        name,
        action: 'getAll',
        tokenScope: 'server'
      }).then(this.redirectUserToOldClientPanel)
        .finally(this.toggleLoading)
    },
    autoLoginToClientPanel (user) {
      let data = new FormData()
      data.append('grant_type', 'client_credentials')
      data.append('client_id', process.env.VUE_APP_SERVER_CLIENT_ID)
      data.append('client_secret', process.env.VUE_APP_SERVER_CLIENT_SECRET)
      this.toggleLoading()
      this.handleRequest({
        name: 'auth/token',
        action: 'create',
        data
      }).then(res => {
        this.handleAuthSuccess(res, user)
      })
    },
    autoLoginToOldClientPanel (user) {
      let data = new FormData()
      data.append('grant_type', 'client_credentials')
      data.append('client_id', process.env.VUE_APP_SERVER_CLIENT_ID)
      data.append('client_secret', process.env.VUE_APP_SERVER_CLIENT_SECRET)
      this.toggleLoading()
      this.handleRequest({
        name: 'auth/token',
        action: 'create',
        data
      }).then(res => {
        this.handleOldClientAuthSuccess(res, user)
      })
    },
    getData () {
      const { domainsPath, limit, offset, query } = this
      console.log('this.query', this.self)
      this.toggleLoading()
      this.handleRequest({
        name: `${domainsPath}/users`,
        action: 'getAll',
        mutation: 'SET_USERS',
        data: {
          query: {
            limit,
            offset,
            ...query
          }
        }
      }).finally(this.toggleLoading)
    }
  },
  watch: {
    currentPage () {
      this.getData()
    }
  },
  components: {
    Search,
    Edit,
    Add
  },
  created () {
    this.getData()
  }
}
</script>
